"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CMFundingRatePublish$ = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const trade_utils_lib_1 = require("trade_utils_lib");
const CMFundingRateRequest = () => {
    const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/orders/coin_margined_funding_fee_rates/`;
    const fetchData = trade_utils_lib_1.ObservableUtils.get(url, undefined, undefined, false);
    const modelParam = {
        keyId: "common_data",
        dataKey: `cm_fsa_funding_fee_rate`,
        expireTime: trade_utils_lib_1.EXPIRED_TYPE.NEVER,
        refresh: () => fetchData,
    };
    return (0, trade_utils_lib_1.getDataWithCache)(modelParam);
};
exports.CMFundingRatePublish$ = (0, rxjs_1.interval)(30000).pipe((0, operators_1.startWith)(0), (0, operators_1.exhaustMap)(() => {
    return (0, trade_utils_lib_1.requestWithRetry)(() => CMFundingRateRequest(), {
        name: "CMFundingRateRequest",
    });
}), (0, operators_1.publishBehavior)(Array()), (0, operators_1.refCount)());
